<template>
  <div class="container py-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0">Nhân sự: Phiếu công (Mock)</h4>
      <div class="text-muted small">
        userId: <b>{{ userId }}</b>
      </div>
    </div>

    <div class="card p-3 mb-3">
      <div class="d-flex gap-2 align-items-end flex-wrap">
        <div>
          <label class="small text-muted">Tháng</label>
          <input v-model="month" type="month" class="form-control" style="width: 160px" />
        </div>
        <button class="btn btn-outline-primary" @click="load" :disabled="store.loading">
          Tải
        </button>

        <div class="ms-auto small text-muted">
          Demo link nhanh:
          <a href="/employee/phieu-cong?userId=1">user 1</a> |
          <a href="/employee/phieu-cong?userId=2">user 2</a>
        </div>
      </div>
    </div>

    <div v-if="store.error" class="alert alert-danger">{{ store.error }}</div>
    <div v-if="store.loading" class="alert alert-info">Đang tải...</div>

    <div v-if="slip" class="card p-3">
      <div class="d-flex justify-content-between flex-wrap">
        <div>
          <div class="fw-bold">{{ slip.hoTen }} ({{ slip.phongBan }})</div>
          <div class="text-muted small">Mode: {{ slip.kieuChamCong }}</div>
        </div>
        <div><span class="badge bg-secondary">Status: {{ slip.status }}</span></div>
      </div>

      <hr />

      <div class="row g-2">
        <div class="col-md-3"><div class="p-2 border rounded">Tổng công: <b>{{ slip.totalCong }}</b></div></div>
        <div class="col-md-3"><div class="p-2 border rounded">Trễ (phút): <b>{{ slip.stats.minutesTre }}</b></div></div>
        <div class="col-md-3"><div class="p-2 border rounded">Quên chấm: <b>{{ slip.stats.quenCham }}</b></div></div>
        <div class="col-md-3"><div class="p-2 border rounded">CN công: <b>{{ slip.stats.sundayCong }}</b></div></div>
      </div>

      <div class="table-responsive mt-3">
        <table class="table table-sm table-bordered align-middle">
          <thead>
            <tr class="table-light">
              <th>Ngày</th><th>CN</th><th>Công</th><th>Công S</th><th>Công C</th>
              <th>Trễ</th><th>Ra sớm</th><th>Quên chấm</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in slip.snapshot.daily" :key="d.day">
              <td>{{ d.day }}</td>
              <td>{{ d.sunday ? "✓" : "" }}</td>
              <td>{{ d.soCong }}</td>
              <td>{{ d.soCongAm }}</td>
              <td>{{ d.soCongPm }}</td>
              <td>{{ d.tongVaoTre }}</td>
              <td>{{ d.tongRaSom }}</td>
              <td>{{ d.tongQuenCham }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-3">
        <div v-if="slip.status === 'PUBLISHED'" class="alert alert-warning">
          Phiếu đã công bố. Vui lòng ký xác nhận.
        </div>

        <SignaturePad v-if="slip.status === 'PUBLISHED'" @signed="onSigned" />

        <div v-else-if="slip.status === 'SIGNED'" class="alert alert-info">
          Bạn đã ký lúc: <b>{{ slip.signature?.signedAt }}</b>
        </div>

        <div v-else-if="slip.status === 'VERIFIED'" class="alert alert-success">
          Admin đã xác minh. Phiếu lương:
          <a :href="slip.payrollPdfUrl" target="_blank">{{ slip.payrollPdfUrl }}</a>
        </div>

        <div v-else-if="slip.status === 'REJECTED'" class="alert alert-danger">
          Bị từ chối: {{ slip.adminNote }}
        </div>
      </div>
    </div>

    <div v-else class="alert alert-secondary">
      Không có phiếu công (mock chỉ có tháng 2025-12).
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { usePhieuCongStore } from "@/stores/phieuCongStore";
import SignaturePad from "@/views/SignaturePad.vue";

const store = usePhieuCongStore();
const route = useRoute();

const month = ref("2025-12");
const userId = computed(() => Number(route.query.userId || 1));
const slip = computed(() => store.mySlip);

function load() {
  store.fetchMy(month.value, userId.value);
}

function onSigned({ name, imageDataUrl }) {
  store.signMy({ month: month.value, userId: userId.value, name, imageDataUrl });
}

watch(() => route.query.userId, load);
onMounted(load);
</script>
